module.exports = __webpack_public_path__ + "static/media/middle-left-3.326afa10.png";